import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 4,
    "& svg": {
      width: 16,
      height: 16,
      color: theme.palette.grey[500],
    },
    "&:hover": {
      border: `1px solid ${theme.palette.grey[900]}`,
    },
    "&:focus": {
      border: `1px solid ${theme.palette.grey[900]}`,
    },
  },
  rootIcon: {
    background: "transparent",
    "& svg": {
      width: 24,
      height: 24,
      color: theme.palette.grey[700],
    },
  },
}));
